import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import Logo from "~/components/header/Logo";
import MobileMenu from "~/components/pages/dashboard/MobileMenu.vue";

var MobileHeader = /*#__PURE__*/function (_Vue) {
  _inherits(MobileHeader, _Vue);

  var _super = _createSuper(MobileHeader);

  function MobileHeader() {
    _classCallCheck(this, MobileHeader);

    return _super.apply(this, arguments);
  }

  _createClass(MobileHeader, [{
    key: "toggleMobileNav",
    value: function toggleMobileNav() {
      var mobileNav = document.getElementById("navbarSupportedContent");
      mobileNav.classList.toggle("show");
    }
  }]);

  return MobileHeader;
}(Vue);

MobileHeader = __decorate([Component({
  components: {
    MobileMenu: MobileMenu,
    Logo: Logo
  }
})], MobileHeader);
export default MobileHeader;